import React from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { CustomerSupplierListType } from "../../../../redux/clientSettings/clientSettingTypes";
import { TableLoader, TableHeader } from "../../../commons";
import InfiniteLoader from "../../../commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../../commons/ScrollToTop";
import CustomerSupplierTableData from "./CustomerSupplierTableData";
import { LedgerPdfDataType } from "../../../../screens/ClientSettings/CustomerSupplierManager";

type AppProps = {
  data: any[];
  headers: TableHeadersType[];
  fetching: boolean;
  handleSetJobsData?: (data: any) => void;
  handleToggleProgressCommentsModal?: () => void;
  handleRedirectToEditForm?: (data: CustomerSupplierListType) => void;
  isAdminReport?: boolean;
  isEdit: boolean;
  isEditCustomerSupplierPresent: boolean;
  offset?: number;
  handleEnableDisableStatus: (data: any) => void;
  isChangeStatusCustomerSupplierPresent: boolean;
  handleLedgerStatementDownloadModal: () => void;
  handleSetLedgerStatementEmailData: (data: LedgerPdfDataType) => void;
};

const JobProgressTable = ({
  data,
  headers,
  fetching,
  handleRedirectToEditForm,
  isEdit,
  isEditCustomerSupplierPresent,
  offset,
  handleEnableDisableStatus,
  isChangeStatusCustomerSupplierPresent,
  handleLedgerStatementDownloadModal,
  handleSetLedgerStatementEmailData,
}: AppProps) => {
  return (
    <>
      {/* {fetching ? <TableLoader
        Rows={10}
        ColumnPerRow={5}
      /> : */}
      <div className="jobsType" style={{ overflowX: "scroll" }}>
        <table className="table table-bordered thead-light">
          <thead className="text-start sticky-table-header">
            <TableHeader tableHeader={headers} extraHeader />
          </thead>
          <tbody>
            <CustomerSupplierTableData
              data={data}
              tableHeader={headers}
              handleRedirectToEditForm={handleRedirectToEditForm}
              isEdit={isEdit}
              isEditCustomerSupplierPresent={isEditCustomerSupplierPresent}
              handleEnableDisableStatus={handleEnableDisableStatus}
              isChangeStatusCustomerSupplierPresent={
                isChangeStatusCustomerSupplierPresent
              }
              handleLedgerStatementDownloadModal={
                handleLedgerStatementDownloadModal
              }
              handleSetLedgerStatementEmailData={
                handleSetLedgerStatementEmailData
              }
            />
            <div style={{ display: fetching ? "none" : "inline" }}>
              <ScrollToTop />
            </div>
            {fetching && offset && offset > 0 && (
              <div>{<InfiniteLoader />}</div>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default JobProgressTable;
